import React, { createContext, useState, useContext, useEffect } from 'react';
import proyecto from '../services/api/Proyecto';

// Crear el contexto
export const AuthContext = createContext();

// Proveedor del contexto
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Función para iniciar sesión con múltiples PINs y roles
  const login = async ({ username, pin }) => {
    const trimmedUsername = String(username || '').trim();
    const trimmedPin = String(pin || '').trim();
    if (!trimmedUsername || !trimmedPin) return false;

    try {
      const response = await proyecto.post('/auth/login', {
        username: trimmedUsername,
        pin: trimmedPin,
      });

      const { token, user: userFromServer } = response.data || {};
      if (!token || !userFromServer) return false;

      localStorage.setItem('token', token);

      const userData = {
        ...userFromServer,
        role: userFromServer.rol,
        isAuthenticated: true,
      };

      setUser(userData);
      localStorage.setItem('auth', JSON.stringify(userData));
      return true;
    } catch (error) {
      console.error('Error de login:', error.response?.data || error.message);
      return false;
    }
  };

  // Función para cerrar sesión
  const logout = () => {
    setUser(null);
    localStorage.removeItem('auth');
    localStorage.removeItem('token');
  };

  // Cargar datos del usuario al iniciar
  useEffect(() => {
    const storedUser = localStorage.getItem('auth');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook para usar el contexto de autenticación
export const useAuth = () => {
  return useContext(AuthContext);
};
